import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const ActiveOperatorsSkeleton = () => {
  return (
    <Box className={styles['active-operators-skeleton__container']} width="364px">
      <SkeletonComponent width="91px" height="23px" mb="16px" />

      <Box className={styles['active-operators-skeleton__box']}>
        <Iteration
          items={[1, 2, 3]}
          render={(idx) => (
            <Flex padding="14px 24px" gap="16px" key={idx}>
              <SkeletonComponent width="32px" height="32px" borderRadius="8px" />
              <SkeletonComponent height="32px" flex={1} />
            </Flex>
          )}
        />
      </Box>
    </Box>
  );
};

export default ActiveOperatorsSkeleton;
